import React, { Component } from "react"

class Instagram extends Component {
  render() {
    let { color } = this.props
    return (
      <svg
        width="16px"
        height="15px"
        viewBox="0 0 16 15"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="/g/footer"
            transform="translate(-1286.000000, -159.000000)"
            fill={color}
          >
            <path
              d="M1290.392,166.4346 C1290.392,164.3536 1292.081,162.6566 1294.161,162.6566 C1296.25,162.6566 1297.939,164.3536 1297.939,166.4346 C1297.939,168.5226 1296.25,170.2126 1294.161,170.2126 C1292.081,170.2126 1290.392,168.5226 1290.392,166.4346 M1298.062,159.0506 L1290.27,159.0506 C1288.352,159.0506 1286.778,160.6176 1286.778,162.5426 L1286.778,170.3346 C1286.778,172.2516 1288.352,173.8266 1290.27,173.8266 L1298.062,173.8266 C1299.987,173.8266 1301.553,172.2516 1301.553,170.3346 L1301.553,162.5426 C1301.553,160.6176 1299.987,159.0506 1298.062,159.0506 M1290.27,159.9236 L1298.062,159.9236 C1299.506,159.9236 1300.681,161.0986 1300.681,162.5426 L1300.681,170.3346 C1300.681,171.7786 1299.506,172.9536 1298.062,172.9536 L1290.27,172.9536 C1288.825,172.9536 1287.651,171.7786 1287.651,170.3346 L1287.651,162.5426 C1287.651,161.0986 1288.825,159.9236 1290.27,159.9236 M1298.837,161.0256 C1298.412,161.0256 1298.07,161.3676 1298.07,161.7916 C1298.07,162.2166 1298.412,162.5586 1298.837,162.5586 C1299.261,162.5586 1299.604,162.2166 1299.604,161.7916 C1299.604,161.3676 1299.261,161.0256 1298.837,161.0256 M1298.926,166.4346 C1298.926,163.8076 1296.797,161.6696 1294.161,161.6696 C1291.534,161.6696 1289.397,163.8076 1289.397,166.4346 C1289.397,169.0696 1291.534,171.1996 1294.161,171.1996 C1296.797,171.1996 1298.926,169.0696 1298.926,166.4346"
              id="Fill-6"
            ></path>
          </g>
        </g>
      </svg>
    )
  }
}
class Facebook extends Component {
  render() {
    let { color } = this.props
    return (
      <svg
        width="9px"
        height="17px"
        viewBox="0 0 9 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <polygon
            id="path-1"
            points="0.1756 0.124 8.0686 0.124 8.0686 17 0.1756 17"
          ></polygon>
        </defs>
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="/g/footer"
            transform="translate(-1327.000000, -158.000000)"
            fill={color}
          >
            <g
              id="Group-5"
              transform="translate(1327.000000, 157.876500)"
              fill={color}
            >
              <g id="Clip-4"></g>
              <path
                fill={color}
                d="M5.3856,5.1784 L5.3856,3.8234 C5.3856,3.1734 5.8156,3.0174 6.1276,3.0174 L8.0226,3.0174 L8.0226,0.1234 L5.4136,0.1234 C2.5106,0.1234 1.8606,2.2664 1.8606,3.6584 L1.8606,5.1784 L0.1756,5.1784 L0.1756,7.2204 L0.1756,8.5574 L1.8786,8.5574 L1.8786,17.0004 L5.2576,17.0004 L5.2576,8.5574 L7.7576,8.5574 L7.8676,7.2294 L8.0686,5.1784 L5.3856,5.1784 Z"
                id="Fill-3"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}
class LinkedIn extends Component {
  render() {
    let { color } = this.props
    return (
      <svg
        width="16px"
        height="15px"
        viewBox="0 0 16 15"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="/g/footer"
            transform="translate(-1360.000000, -159.000000)"
            fill={color}
          >
            <path
              d="M1360.9478,166.5873 L1360.9478,173.5693 L1364.2728,173.5693 L1364.2728,166.0183 L1364.2728,164.0593 L1360.9478,164.0593 L1360.9478,166.5873 Z M1375.1308,166.9813 C1374.9118,165.1783 1374.0898,164.0593 1371.6568,164.0593 C1370.2308,164.0593 1369.2688,164.5843 1368.8658,165.3453 L1368.8218,165.3453 L1368.8218,164.0593 L1366.1708,164.0593 L1366.1708,165.8873 L1366.1708,173.5693 L1368.9448,173.5693 L1368.9448,168.8533 C1368.9448,167.6113 1369.1898,166.4123 1370.7128,166.4123 C1372.2428,166.4123 1372.3568,167.8293 1372.3568,168.9413 L1372.3568,173.5693 L1375.2088,173.5693 L1375.2088,168.3463 C1375.2088,167.8563 1375.1828,167.4013 1375.1308,166.9813 L1375.1308,166.9813 Z M1362.6098,159.3083 C1361.6918,159.3083 1360.9478,160.0513 1360.9478,160.9703 C1360.9478,161.8893 1361.6918,162.6323 1362.6098,162.6323 C1363.5288,162.6323 1364.2728,161.8893 1364.2728,160.9703 C1364.2728,160.0513 1363.5288,159.3083 1362.6098,159.3083 L1362.6098,159.3083 Z"
              id="Fill-1"
            ></path>
          </g>
        </g>
      </svg>
    )
  }
}
class Twitter extends Component {
  render() {
    let { color } = this.props
    return (
      <svg
        width="15px"
        height="13px"
        viewBox="0 0 15 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-931.000000, -175.000000)" fill={color}>
            <path d="M944.232964,177.055251 C944.868639,176.649646 945.356401,176.0065 945.585314,175.240358 C944.990139,175.616857 944.332453,175.889138 943.630745,176.036545 C943.070787,175.398093 942.27047,175 941.384751,175 C939.685508,175 938.308505,176.469377 938.308505,178.281453 C938.308505,178.538712 938.334038,178.789398 938.386864,179.028817 C935.830076,178.891738 933.562951,177.586668 932.044198,175.599957 C931.779186,176.086307 931.627751,176.649646 931.627751,177.250542 C931.627751,178.388488 932.170981,179.39311 932.99683,179.982739 C932.49234,179.965839 932.017785,179.816554 931.602219,179.57244 L931.602219,179.612812 C931.602219,181.203308 932.662264,182.529973 934.071844,182.83042 C933.812995,182.90741 933.541821,182.945905 933.260081,182.945905 C933.061983,182.945905 932.868287,182.926188 932.681634,182.887693 C933.072548,184.190885 934.209192,185.141052 935.55626,185.166402 C934.502377,186.047089 933.175559,186.570995 931.734284,186.570995 C931.486001,186.570995 931.240359,186.556912 931,186.525928 C932.362036,187.456377 933.979398,188 935.71738,188 C941.378588,188 944.472442,182.999422 944.472442,178.662646 C944.472442,178.519934 944.470681,178.37816 944.464518,178.238264 C945.065857,177.775386 945.588836,177.197024 946,176.538856 C945.447966,176.79987 944.854552,176.976383 944.232964,177.055251 Z"></path>
          </g>
        </g>
      </svg>
    )
  }
}
class WhatsApp extends Component {
  render() {
    let { color } = this.props
    return (
      <svg
        width="17px"
        height="17px"
        viewBox="0 0 17 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <polygon
            id="path-1"
            points="0 0.0174986861 18 0.0174986861 18 16.42 0 16.42"
          ></polygon>
        </defs>
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="/g/footer" transform="translate(-1212.000000, -158.000000)">
            <g id="Group-12" transform="translate(1212.000000, 157.000000)">
              <g id="Group-6" transform="translate(0.000000, 1.000000)">
                <path
                  d="M12.3222809,10.3371951 C11.7892705,10.892656 11.1783831,11.1693256 10.5051023,11.1591752 C8.88293172,11.1348888 7.37998526,9.49227624 7.36516109,9.47587506 L7.34420082,9.45488614 C7.32765625,9.43997597 5.68650386,7.94296685 5.66092716,6.31684145 C5.65031799,5.64330347 5.92687322,5.03129859 6.48285101,4.49780146 C6.49724507,4.48398089 6.5154527,4.4770706 6.53345961,4.4770706 C6.5513805,4.4770706 6.56910068,4.48386619 6.58272056,4.49745738 L7.99052858,5.90532093 C8.00781866,5.92263965 8.01125947,5.94239562 8.01108743,5.95590079 C8.01094406,5.96940596 8.00704448,5.98904723 7.9893243,6.00596453 L7.52143128,6.45183578 C7.28100458,6.68090751 7.1615224,7.01079488 7.20175122,7.33425942 C7.25706227,7.77875434 7.54262095,8.26167161 8.0505134,8.76953472 C8.55837717,9.27742652 9.04132374,9.56298483 9.48584791,9.6182958 C9.8090548,9.65852457 10.1390573,9.53901387 10.3681867,9.29861615 L10.8140585,8.83075242 C10.8309758,8.81300359 10.8506458,8.809104 10.864151,8.80893196 L10.8650398,8.80893196 C10.878545,8.80893196 10.8977562,8.81257349 10.9147309,8.82951946 L12.3226249,10.237383 C12.3498934,10.2646801 12.3497213,10.3085217 12.3222809,10.3371951 L12.3222809,10.3371951 Z M11.3171625,8.4270884 C11.1942968,8.30428027 11.0311737,8.23772932 10.8573554,8.23985115 C10.6837091,8.24191564 10.5220196,8.31230882 10.4021073,8.43809899 L9.95620684,8.90596272 C9.85094668,9.01641263 9.70121404,9.07155156 9.55609781,9.053516 C9.33901128,9.02650566 8.97136057,8.88548992 8.4529163,8.36710367 C7.93458672,7.84874609 7.7935708,7.48109586 7.76656043,7.26398093 C7.74849617,7.11866418 7.80363517,6.96913244 7.91405655,6.86384375 L8.38192089,6.4179725 C8.50771122,6.2981464 8.57810449,6.13648581 8.58016898,5.96275373 C8.58229081,5.78905032 8.5158258,5.62575535 8.39293149,5.50288987 L6.98509479,4.09502632 C6.7408832,3.85078637 6.33870968,3.84728822 6.08879207,4.08714114 C5.41410628,4.73455766 5.07868451,5.48775032 5.09184561,6.32581622 C5.12043302,8.14198887 6.78541303,9.71469574 6.95232106,9.86778298 C7.10537983,10.0346335 8.67806006,11.69964 10.4942637,11.7281987 C10.5101201,11.7284567 10.5259765,11.7285714 10.5417183,11.7285714 C11.3607461,11.7285714 12.0977392,11.3931788 12.7328844,10.7312535 L12.7329417,10.7312248 C12.9727949,10.4811929 12.9692108,10.0791346 12.7249992,9.8348946 L11.3171625,8.4270884 Z"
                  id="Fill-1"
                  fill={color}
                ></path>
                <g id="Group-5" transform="translate(0.400044, 0.000000)">
                  <g id="Clip-4"></g>
                  <path
                    d="M8.36129921,14.2124988 C7.48085896,14.2124988 6.62234302,14.0572279 5.80947173,13.7510908 C5.74614518,13.7272099 5.67984585,13.7259514 5.61881083,13.7418021 C5.57341391,13.7417122 5.52739765,13.7502818 5.48385872,13.7708368 L1.19716263,15.7935231 C1.12340037,15.8282208 1.06883735,15.7950812 1.0427945,15.7723089 C1.01672069,15.7494468 0.977238367,15.7000669 1.0056966,15.6257274 L2.57811482,11.5175214 C2.57830062,11.5170719 2.57845545,11.5165925 2.57864125,11.516143 L2.58096374,11.5100604 C2.58306947,11.5045172 2.5836888,11.4988841 2.58545389,11.4932809 C2.58926277,11.4812355 2.59310262,11.4692202 2.59523931,11.4567853 C2.59694247,11.4474068 2.59715923,11.4380881 2.59790243,11.4287395 C2.59864563,11.4190912 2.59976042,11.4095628 2.59951269,11.3998547 C2.59923399,11.3893375 2.59762373,11.37909 2.59623024,11.3687825 C2.59505351,11.360183 2.59434128,11.3516134 2.59239039,11.3430439 C2.58982017,11.3317177 2.58582549,11.3209308 2.58189274,11.3100241 C2.57935348,11.3028928 2.57740259,11.2956716 2.57424401,11.2886901 C2.56808167,11.2749968 2.56030907,11.2621124 2.55213391,11.2494079 C2.55002818,11.2461719 2.54875856,11.2426661 2.54652897,11.23946 C2.5453832,11.2379019 2.54439228,11.2362539 2.54327748,11.2346659 C2.54281298,11.2340666 2.54244138,11.2333774 2.54197689,11.2327782 C1.74554882,10.1018057 1.32449698,8.77792825 1.32449698,7.40362219 C1.32449698,3.64916522 4.48122456,0.59471562 8.36129921,0.59471562 C12.2413739,0.59471562 15.3981014,3.64916522 15.3981014,7.40362219 C15.3981014,11.1580492 12.2413739,14.2124988 8.36129921,14.2124988 M8.36129921,-2.13162821e-14 C4.14223401,-2.13162821e-14 0.709842422,3.32124464 0.709842422,7.40362219 C0.709842422,8.84855223 1.13910039,10.2418851 1.95057819,11.4446201 L0.429347636,15.4191591 C0.321707995,15.7002766 0.400579734,16.011927 0.630227486,16.2131619 C0.772518669,16.3377801 0.952558047,16.4025013 1.13522958,16.4025013 C1.24739033,16.4025013 1.36060395,16.3780211 1.4665714,16.328042 L5.68077485,14.339574 C6.53696831,14.6496364 7.43812516,14.8072444 8.36129921,14.8072444 C12.5803334,14.8072444 16.012756,11.4859698 16.012756,7.40362219 C16.012756,3.32124464 12.5803334,-2.13162821e-14 8.36129921,-2.13162821e-14"
                    id="Fill-3"
                    fill={color}
                    mask="url(#mask-2)"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}
class RealEstate extends Component {
  render() {
    let { color } = this.props
    return (
      <svg
        width="17px"
        height="17px"
        viewBox="0 0 17 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Symbols"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="/g/footer"
            transform="translate(-1249.000000, -158.000000)"
            fill={color}
          >
            <path
              d="M1257.2486,158.2294 L1257.2016,158.2294 C1252.6976,158.2294 1249.0156,161.8794 1249.0006,166.3984 C1248.9686,170.9334 1252.6346,174.6314 1257.1696,174.6474 C1261.7046,174.6784 1265.4026,171.0134 1265.4176,166.4774 C1265.4496,161.9424 1261.7836,158.2454 1257.2486,158.2294 M1262.8736,166.0674 C1262.8736,166.6514 1262.4156,167.1254 1261.8306,167.1254 L1261.1516,167.1254 L1261.1516,170.8234 C1261.1516,171.2024 1260.8516,171.5184 1260.4726,171.5184 L1253.8986,171.5184 C1253.5196,171.5184 1253.2196,171.2024 1253.2196,170.8234 L1253.2196,167.1254 L1252.5556,167.1254 C1251.9866,167.1254 1251.5126,166.6514 1251.5126,166.0674 C1251.5126,165.7824 1251.6236,165.5144 1251.8126,165.3244 L1256.6956,160.4734 C1256.8216,160.3314 1256.9956,160.2524 1257.2016,160.2524 C1257.4066,160.2524 1257.5806,160.3314 1257.7066,160.4734 L1262.5896,165.3244 C1262.7796,165.5144 1262.8896,165.7664 1262.8736,166.0674"
              id="Fill-10"
            ></path>
          </g>
        </g>
      </svg>
    )
  }
}
export { Instagram, LinkedIn, Facebook, Twitter, WhatsApp, RealEstate }
